/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC,useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../helpers";
import { useLayout } from "../../../core";
import { usePermissionValues } from "../../../../../app/commonComponents/useCheckPermission";
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import { useAuth } from "../../../../../app/modules/auth";

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  menuTrigger?: 'click' | `{default:'click', lg: 'hover'}`
  menuPlacement?: 'right-start' | 'bottom-start' | 'left-start' | 'bottom-end'
  hasArrow?: boolean
  hasBullet?: boolean
  isMega?: boolean
}

const MegaManage: FC<Props & WithChildren>  = (
  {children,
    to,
    title,
    icon,
    fontIcon,
    menuTrigger,
    menuPlacement,
    hasArrow = false,
    hasBullet = false,
    isMega = false,
  }
) => {
  const { setLayoutType, setToolbarType } = useLayout();
  const {pathname} = useLocation()
  const menuItemRef = useRef<HTMLDivElement>(null);

  const { currentUser } = useAuth();

  const {
    permissionContentPartner, permissionAdminUsers, permissionRoles, 
	permissionBroadcastGroups, permissionBroadcastMessages, permissionCDNManagement,
	permissionFeedbacks, permissionStorageSettings, permissionEPGLibrary, permissionGeoFencing, permissionStaticWebPages, permissionActivityTracker,
    permissionUserManagement, permissionSocialLinks, permissionDevicePlaybackConfig, permissionImageConfig, permissionAdSettings, permissionEmailTemplate, permissionSMSTemplate
    } = usePermissionValues();

    const permission_Accounts =  permissionUserManagement.isViewable || permissionAdminUsers.isViewable || 
	                             permissionContentPartner.isViewable || permissionRoles.isViewable;

	const permission_Broadcast = permissionBroadcastGroups.isViewable || permissionBroadcastMessages.isViewable;

	const permission_App_Settings = permissionSocialLinks.isViewable || permissionDevicePlaybackConfig.isViewable || permissionAdSettings.isViewable ||
									permissionGeoFencing.isViewable;

	const permission_Manage_Temp = permissionStaticWebPages.isViewable || permissionEmailTemplate.isViewable || permissionSMSTemplate.isViewable;



  useEffect(() => {
    if (menuItemRef.current && menuTrigger && menuPlacement) {
      menuItemRef.current.setAttribute('data-kt-menu-trigger', menuTrigger)
      menuItemRef.current.setAttribute('data-kt-menu-placement', menuPlacement)
    }
  }, [menuTrigger, menuPlacement])

  return (
  <div
    className="menu-state-bg menu-extended overflow-hidden overflow-lg-visible user-select-none"
    data-kt-menu-dismiss="true"
  >
    <div className="py-4 py-lg-8 px-lg-4">
	{/* <div className="tab-pane active w-lg-1000px" id="kt_app_header_menu_pages_pages"></div> */}
				{/* <div className="row"> */}
				{/* <div className="d-flex flex-wrap g-3"> */}
				<div className="d-flex w-100 justify-content-evenly">
				{((permission_Accounts) || (permission_Broadcast)) && (
					// <div className="col-lg-4 mb-6 mb-lg-0">
					<div className="flex-fill mb-6 mb-lg-0">
						{(permission_Accounts) && (
					    <div className="mb-6">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Accounts</h4>
								{(permissionUserManagement.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/accounts/users"
									className={clsx('menu-link bg-hover-secondary', {
									active: checkIsActive(pathname, '/manage/accounts/users'),
									})}
								>										
			                		<span className="menu-title">Customers</span>
								</Link>
								</div>
								)}

								{(permissionAdminUsers.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/accounts/admins"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/accounts/admins'),
									})}
								>										
			                		<span className="menu-title">Admins</span>
								</Link>
								</div>
								)}

								{(permissionContentPartner.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/accounts/cont-partner"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/accounts/cont-partner'),
									})}
								>										
			                		<span className="menu-title">Content Partner</span>
								</Link>
								</div>
								)}

								{(permissionRoles.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/accounts/roles"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/accounts/roles'),
									})}
								>										
			                		<span className="menu-title">Roles</span>
								</Link>
								</div>	
								)}															
						</div>
						)}

					    {(permission_Broadcast) && (
					    <div className="mb-3">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Notification</h4>
							{(permissionBroadcastMessages.isViewable) && (
							<div className="menu-item p-0 m-0">
								<Link
									to="/manage/notification/broadcast"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/notification/broadcast'),
									})}
								>										
			                		<span className="menu-title">Broadcast</span>
								</Link>
							</div>	 
							)}
							{(permissionBroadcastGroups.isViewable) && (
							<div className="menu-item p-0 m-0">
								<Link
									to="/manage/notification/groups"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/notification/groups'),
									})}
								>										
			                		<span className="menu-title">Groups</span>
								</Link>
							</div>	
							)} 							
						</div>  
						)}                                																		

						{(currentUser?.userType === "SUPERADMIN") && (
					    <div className="mb-0">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Audits</h4>
							{(currentUser?.userType === "SUPERADMIN") && (
							<div className="menu-item p-0 m-0">
								<Link
									to="/manage/audits/activity-tracker"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/audits/activity-tracker'),
									})}
								>										
			                		<span className="menu-title">Activity Tracker</span>
								</Link>
							</div>	 
							)}						
						</div>  
						)}                                																		
                            																		
																		
					</div>
					)}

					{((permission_App_Settings)) && (
					// <div className="col-lg-4 mb-6 mb-lg-0">
					<div className="flex-fill mb-6 mb-lg-0">
						{(permission_App_Settings) && (
					    <div className="mb-6">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">App Settings</h4>
						    {(permissionAdSettings.isViewable) && (						
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/app-settings/ad-settings"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/app-settings/ad-settings'),
									})}
								>										
			                		<span className="menu-title">Ads Settings</span>
								</Link>
								</div>
						    )}

							{(permissionDevicePlaybackConfig.isViewable) && (
							<div className="menu-item p-0 m-0">
							<Link
								to="/manage/app-settings/device-config"
								className={clsx('menu-link bg-hover-secondary ', {
								active: checkIsActive(pathname, '/manage/app-settings/device-config'),
								})}
							>										
								<span className="menu-title">Device Config</span>
							</Link>
							</div>
							)}						    				   																																			
							{(permissionSocialLinks.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/app-settings/social-links"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/app-settings/social-links'),
									})}
								>										
			                		<span className="menu-title">Social Links</span>
								</Link>
								</div>
							)}
								{/* {(permissionImageConfig.isViewable) && (						
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/app-settings/image-config/login"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/app-settings/image-config/login'),
									})}
								>										
			                		<span className="menu-title">Assets</span>
								</Link>
								</div>
								)} */}

								{(permissionGeoFencing.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/app-settings/geo-fencing"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/app-settings/geo-fencing'),
									})}
								>										
			                		<span className="menu-title">Geo Fencing</span>
								</Link>
								</div>
								)}
						</div>
						)}
						{(permission_Manage_Temp) && (
					    <div className="mb-6">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Manage Templates</h4>
						   
						    {(permissionEmailTemplate.isViewable) && (						
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/manage-template/email-templates"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/manage-template/email-templates'),
									})}
								>										
			                		<span className="menu-title">Email Templates</span>
								</Link>
								</div>
						    )}
						    {(permissionStaticWebPages.isViewable) && (						
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/manage-template/static-web"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/manage-template/static-web'),
									})}
								>										
			                		<span className="menu-title">Static Web Pages</span>
								</Link>
								</div>
						    )}	
						    {(permissionSMSTemplate.isViewable) && (						
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/manage-template/sms-templates"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/manage-template/sms-templates'),
									})}
								>										
			                		<span className="menu-title">SMS Templates</span>
								</Link>
								</div>
						    )}																																																
						</div>
						)}
                        	
				     										
				

					

																		
					</div>		
					)}			
																	
					{((currentUser?.userType === "SUPERADMIN") || (permissionStorageSettings.isViewable) 
					|| (permissionEPGLibrary.isViewable || permissionFeedbacks.isViewable)) && (
					// <div className="col-lg-4 mb-6 mb-lg-0">		
					<div className="flex-fill mb-6 mb-lg-0">																
						<div className="mb-6">
							<h4 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Integrations</h4>
							{(currentUser?.userType === "SUPERADMIN") && (
							<>						   
								<div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/email-config"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/email-config'),
									})}
								>										
			                		<span className="menu-title">Email Config</span>
								</Link>
								</div>

								<div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/otp-config"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/otp-config'),
									})}
								>										
			                		<span className="menu-title">OTP Config</span>
								</Link>
								</div>
								
								<div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/sms-config"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/sms-config'),
									})}
								>										
			                		<span className="menu-title">SMS Config</span>
								</Link>
								</div>								
																		
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/tmdb"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/tmdb'),
									})}
								>										
			                		<span className="menu-title">TMDB</span>
								</Link>
								</div>

							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/firebase"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/firebase'),
									})}
								>										
			                		<span className="menu-title">Firebase</span>
								</Link>
								</div>
								</>
								)}
							    {(permissionEPGLibrary.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/epg-library"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/epg-library'),
									})}
								>										
			                		<span className="menu-title">EPG Library</span>
								</Link>
								</div>	
								)}								
							    {(permissionStorageSettings.isViewable) && (
							    <div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/storage"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/storage'),
									})}
								>										
			                		<span className="menu-title">Storage</span>
								</Link>
								</div>	
								)}	
								{(permissionCDNManagement.isViewable) && (
								<div className="menu-item p-0 m-0">
								<Link
									to="/manage/integration/cdn"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/integration/cdn'),
									})}
								>										
			                		<span className="menu-title">CDN Management</span>
								</Link>
								</div>)}
								{(permissionFeedbacks.isViewable) && (
					    <div className="mb-0">
							<h5 className="fs-6 fs-lg-4 fw-bold mb-3 ms-4">Help & Support</h5>
							<div className="menu-item p-0 m-0">
								<Link
									to="/manage/accounts/feedbacks"
									className={clsx('menu-link bg-hover-secondary ', {
									active: checkIsActive(pathname, '/manage/accounts/feedbacks'),
									})}
								>										
			                		<span className="menu-title">Feedbacks</span>
								</Link>
								</div>	 
						</div>    
						)}  																						
						</div>
             		</div>
					)}
				</div>                                  
    </div>
    </div>
  );
};

export { MegaManage };
